import { CONTA_LOCAL, idDoMes, idDoPerfil } from './protocolo.js';
async function substituirPendencias(banco, tabela, ids, linha, dono) {
    const entradasAntigas = await banco.fila
        .filter((entrada) => entrada.tabela === tabela && ids.has(entrada.id))
        .primaryKeys();
    if (entradasAntigas.length > 0)
        await banco.fila.bulkDelete(entradasAntigas);
    // O motor carimba a morta com o dono do ciclo, mesmo quando a entrada ainda
    // usa a identidade da sentinela. Os dois carimbos válidos provam que havia
    // necessidade de envio, mas o payload pode ser justamente o inválido que
    // matou a entrada. A linha validada no banco é a única fonte da nova fila;
    // copiar a morta repetiria o erro. Morta de outra conta fica fora daqui.
    const mortasDaIdentidade = await banco.dead_letter
        .where('user_id')
        .anyOf([CONTA_LOCAL, dono])
        .filter((morta) => morta.tabela === tabela && ids.has(morta.id))
        .primaryKeys();
    if (mortasDaIdentidade.length > 0)
        await banco.dead_letter.bulkDelete(mortasDaIdentidade);
    await banco.fila.add({
        tabela,
        id: linha.id,
        payload: { ...linha },
        em: linha.updated_at,
    });
}
async function adotarPerfil(banco, dono) {
    const origemId = idDoPerfil(CONTA_LOCAL);
    const origem = await banco.perfil.get(origemId);
    const locais = origem !== undefined &&
        (origem.user_id === CONTA_LOCAL || origem.user_id === dono)
        ? [origem]
        : [];
    if (locais.length === 0)
        return;
    const destinoId = idDoPerfil(dono);
    const destino = await banco.perfil.get(destinoId);
    let vencedora = destino;
    let veioDoDestino = destino !== undefined;
    for (const local of locais) {
        if (vencedora === undefined || local.updated_at > vencedora.updated_at) {
            vencedora = local;
            veioDoDestino = false;
        }
    }
    if (vencedora === undefined)
        return;
    const canonica = veioDoDestino
        ? vencedora
        : {
            ...vencedora,
            id: destinoId,
            user_id: dono,
            server_updated_at: null,
        };
    const ids = new Set([...locais.map((linha) => linha.id), destinoId]);
    await banco.perfil.bulkDelete(locais.map((linha) => linha.id));
    await banco.perfil.put(canonica);
    await substituirPendencias(banco, 'perfil', ids, canonica, dono);
}
async function adotarMeses(banco, dono) {
    const locais = await banco.mes
        .filter((linha) => (linha.user_id === CONTA_LOCAL || linha.user_id === dono) &&
        linha.id === idDoMes(CONTA_LOCAL, linha.ano, linha.mes))
        .toArray();
    const porDestino = new Map();
    for (const local of locais) {
        const destinoId = idDoMes(dono, local.ano, local.mes);
        porDestino.set(destinoId, [...(porDestino.get(destinoId) ?? []), local]);
    }
    for (const [destinoId, fontes] of porDestino) {
        const destino = await banco.mes.get(destinoId);
        let vencedora = destino;
        let veioDoDestino = destino !== undefined;
        for (const fonte of fontes) {
            if (vencedora === undefined || fonte.updated_at > vencedora.updated_at) {
                vencedora = fonte;
                veioDoDestino = false;
            }
        }
        if (vencedora === undefined)
            continue;
        const canonica = veioDoDestino
            ? vencedora
            : {
                ...vencedora,
                id: destinoId,
                user_id: dono,
                server_updated_at: null,
            };
        const ids = new Set([...fontes.map((linha) => linha.id), destinoId]);
        await banco.mes.bulkDelete(fontes.map((linha) => linha.id));
        await banco.mes.put(canonica);
        await substituirPendencias(banco, 'mes', ids, canonica, dono);
    }
}
/**
 * Troca as identidades de perfil e mês que foram derivadas da sentinela.
 * Deve rodar na mesma transação da adoção do dono, depois da purga de linhas
 * estrangeiras: a chave canônica pode já existir, e o LWW precisa enxergar
 * apenas candidatas que realmente pertencem à conta que entrou.
 */
export async function adotarIdentidadesDerivadas(banco, dono) {
    await banco.transaction('rw', [banco.perfil, banco.mes, banco.fila, banco.dead_letter], async () => {
        await adotarMeses(banco, dono);
        await adotarPerfil(banco, dono);
    });
}
//# sourceMappingURL=adocaoDerivada.js.map